import { render, staticRenderFns } from "./brandApply.vue?vue&type=template&id=00347e0d&scoped=true&"
import script from "./brandApply.vue?vue&type=script&lang=js&"
export * from "./brandApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00347e0d",
  null
  
)

export default component.exports